export default "__VITE_ASSET__DI2w9Inn__"